import "bulma/css/bulma.min.css";
import "./app.scss";
import { Skills, Navbar, Hero, Contact } from "./Components";

const App = () => {
	return (
		<div className="App">
			<Navbar />
			<Hero />
			<Skills />
			<Contact />
		</div>
	);
};

export default App;
